<template>
  <div id="accountSettings">
    <div class="right column" style="width: 100%;">
      <div class="right-content">
        <div class="top">
          <img src="../../assets/icon/qrc.png" alt />

          <span style="margin: 0 10px;color: #eee">|</span>
          <span>账号设置</span>
          <div class="floatRight">
            <!-- <span>+{{userList.userName}}</span> -->
             <span>{{this.userList.userName}} </span>
            <span class="exit" @click="dialogVisible = true">退出</span>
          </div>
          <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
            <span>确定退出用户吗</span>
            <span slot="footer" class="dialog-footer" style="z-index:2100">
              <el-button @click="dialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="exit">确 定</el-button>
            </span>
          </el-dialog>
        </div>
        <div class="content">
          <div @click="lastText" class="lastStep row alignCenter">
            <img src="../../assets/icon/syb.png" alt />
            <div class="lastText">上一步</div>
          </div>
          <!-- 表单提交 -->
          <div class="center" style="margin-top:30px">
            <div class="form">
              <el-form ref="form" :model="form" label-width="80px">
                <!-- <el-form-item label="账号：">
                  <div class>
                    <el-input v-model="form.userName" placeholder="请输入账号"></el-input>
                    <div class="exit amend" @click="hrefPassword" style>修改密码</div>
                  </div>
                </el-form-item> -->
                <el-form-item label="昵称：" class="">
                  <el-input v-model="form.nickName" placeholder="请输入昵称"></el-input>
                  <div class="exit amend" @click="hrefPassword" style>修改密码</div>
                </el-form-item>
                <!-- <el-form-item label="QQ：">
                  <el-input v-model="form.qq" placeholder="请输入QQ"></el-input>
                </el-form-item>-->
                <el-form-item label="性别：">
                  <el-radio-group v-model="form.sex">
                    <el-radio label="男"></el-radio>
                    <el-radio label="女"></el-radio>
                    <!-- <el-radio label="保密"></el-radio> -->
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="头像：">
                  <div class="row">
                    <el-upload
                      class="avatar-uploader"
                      action="https://api.yichengshi.cn/ImageServer/YmUpload_image"
                      :show-file-list="false"
                      list-type="picture-card"
                      :http-request="loadImg7"
                    >
                      <img v-if="form.imageUrl" :src="form.imageUrl" class="avatar" />
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                    <!-- <div class="exit" style="height:20px;padding-top:35px;padding-left:10px;">修改</div> -->
                  </div>
                </el-form-item>
                <!-- <el-form-item label="签名：">
                  <el-input type="textarea" placeholder="最多200字" v-model="form.signature"></el-input>
                </el-form-item> -->
                <el-form-item>
                  <el-button type="primary" class="button1" @click="submitForm('form')">确认修改</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { uploadImg } from "../api";
export default {
  name: "accountSettings",
  data() {
    return {
      dialogVisible: false, //控制退出提示弹窗
      form: {
        imageUrl: require("../../assets/icon/mdzp1.png"),
        shopLogo: "",
        nickName: "",
        shopName: "",
        qq: "",
        sex: "",
        signature: ""
      },
      imageUrl: require("../../assets/icon/mdzp1.png"), //门店照片上传图案
      userList: "",
      shopInformation: ""
    };
  },
  created() {
    let userList = JSON.parse(this.getCookie("userList"));
    let shopInformation = JSON.parse(this.getCookie("shopInformation"));
    this.userList = userList;
    this.shopInformation = shopInformation;
    this.Shop_workerInfo();
  },
  methods: {
    //个人信息
    Shop_workerInfo() {
      this.request
        .post("qrcapi/Shop_workerInfo", {
          userId: this.userList.id,
          sessionId: this.userList.sessionId
        })
        .then(res => {
          if (res.code == 1) {
            // this.$message({
            //   type: "success",
            //   message: res.msg
            // });
            var sex
            if( res.data.sex == 0){
              sex = '女'
            }else{
              sex = '男'
            }
            this.form.imageUrl = res.data.headLogo
            this.form.shopLogo = res.data.headLogo
            this.form.nickName = res.data.nickName
            this.form.sex =sex
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          alert("网络错误，不能访问");
          console.log(error);
        });
    },
    //修改账号信息
    User_updateUserInfo(nickName,headLogo,sex) {
      this.request
        .post("qrcapi/User_updateUserInfo", {
          userId: this.userList.id,
          sessionId: this.userList.sessionId,
          nickName: nickName, // 昵称
          // // shopName: "", // 商店名称
          // // phoneNum, //手机号
          headLogo:headLogo, //头像
          sex:sex //0:女 1:男
        })
        .then(res => {
          if (res.code == 1) {
            this.$message({
              type: "success",
              message: res.msg
            });
            this.$router.push('/home')
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          alert("网络错误，不能访问");
          console.log(error);
        });
    },
    // 控制门店照片上传
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },

    //表单提交
    submitForm(formName) {
      var form = this.form
      var sex
      if(form.sex == '男'){
        sex = 1
      }else{
        sex = 0
      }
      this.User_updateUserInfo(form.nickName,form.shopLogo,sex)

      // this.$refs[formName].validate((valid) => {
      //   if (valid) {
      //     alert('submit!');
      //   } else {
      //     console.log('error submit!!');
      //     return false;
      //   }
      // });
    },
    //退出跳转
    exit() {
      var that = this;
      var userId = this.userList.id; //用户Id
      var sessionId = this.userList.sessionId;
      this.request
        .post("qrcapi/Login_loginOut", {
          userId: userId,
          sessionId: sessionId
        })
        .then(function(res) {
          if (res.code == 1) {
            that.$message({
              type: "success",
              message: res.msg
            });
            that.dialogVisible = false;
            that.$router.push("/");
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          alert("网络错误，不能访问");
          console.log(error);
        });
    },
    // 返回山一页
    lastText() {
      this.$router.go(-1);
    },
    // 跳转修改密码
    hrefPassword() {
      this.$router.push("/changePassword");
    },
    loadImg7(res) {
      let imgUploadForm = new FormData();
      imgUploadForm.append("file", res.file);
      imgUploadForm.append("fileContentType", res.file.type);
      imgUploadForm.append("fileFileName", res.file.name);
      imgUploadForm.append("isCompre", 1);
      imgUploadForm.append("isCutImage", 1);

      uploadImg(imgUploadForm)
        .then(res => {
          if (res.data.code == 1) {
            this.$message({
              message: res.data.msg,
              type: "success"
            });
            this.form.shopLogo = res.data.data.url;
            this.form.imageUrl = res.data.data.url;
          } else if (res.data.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(res => {});
    }
  }
};
</script>

<style scoped>
.floatRight {
  position: absolute;
  right: 20px;
  font-size: 10px;
}
.top {
  width: 900px;
  border-bottom: 2px solid #eee;
  padding: 30px 0 10px 0;
  display: flex;
  align-items: center;
  position: relative;
}
.right {
  width: 60%;
  height: 100%;
  float: right;
  margin: 0 auto;
  display: flex;
  justify-content: center;
}
.right-content {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.exit {
  color: #60b4f0;
  cursor: pointer;
}
.content {
  width: 900px;
}
.lastStep {
  font-size: 12px;
  color: #4da1f0;
  width: 100%;
  cursor: pointer;
  margin-top: 15px;
}
.lastStep img {
  width: 17px;
  height: 5px;
}
.lastText {
  margin-left: 10px;
}
.form {
  width: 480px;
}
.amend {
  position: absolute;
  right: -5px;
  top: 10px;
}
.button1 {
  height: 30px;
  width: 80px;
  padding: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/page/accountSettings.vue